export const InnsendingLinje = ({
  text,
  styling = '',
}: {
  text: string,
  styling?: string,
}) => (
  <h4 className={styling}>{text}</h4>
);
